export const QR_BASE_URL = "https://demo.upv.doithappen.pt/p/";
export const DAY_LABELS = { 1: "12 mayo", 2: "13 mayo" };
export const DAY_LONG = { 1: "12 mayo 2027", 2: "13 mayo 2027" };

let SEP = ".";
let DEC = ",";
export const setNumberLocale = (lang) => {
  SEP = lang === "en" ? "," : lang === "fr" ? "\u202F" : ".";
  DEC = lang === "en" ? "." : ",";
};
export const fmt = (n) => {
  const v = Math.round(n);
  return (v < 0 ? "-" : "") + Math.abs(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, SEP);
};
export const fmtDec = (n, d = 1) => (Number.isFinite(n) ? n.toFixed(d).replace(".", DEC) : "0");

export const fullName = (p) => `${p.firstName} ${p.lastName}`;
export const shortName = (p) => `${p.firstName} ${p.lastName.split(" ")[0]}`;
export const initials = (p) => `${p.firstName[0] || ""}${p.lastName[0] || ""}`.toUpperCase();

export const qrValue = (token) => `${QR_BASE_URL}${token.replace("UPV-P-", "")}`;

export function resolveToken(raw) {
  if (!raw) return null;
  const s = String(raw).trim().toUpperCase();
  let m = s.match(/UPV-P-([A-Z0-9]{8})/);
  if (m) return `UPV-P-${m[1]}`;
  m = s.match(/\/P\/([A-Z0-9]{8})/);
  return m ? `UPV-P-${m[1]}` : null;
}

const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const randomToken = () =>
  "UPV-P-" + Array.from({ length: 8 }, () => CHARS[Math.floor(Math.random() * CHARS.length)]).join("");

export const pad = (n) => String(n).padStart(2, "0");
export const minutesToTime = (m) => `${pad(Math.floor(m / 60))}:${pad(m % 60)}`;

export const stampAt = (day, time) => {
  const [h, m] = time.split(":").map(Number);
  return { day, time, ts: new Date(2027, 4, 11 + day, h, m).getTime(), createdAt: 0 };
};

export const nowStamp = (day) => {
  const d = new Date();
  return {
    day,
    time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
    ts: new Date(2027, 4, 11 + day, d.getHours(), d.getMinutes(), d.getSeconds()).getTime(),
    createdAt: Date.now(),
  };
};

export const clockNow = () => {
  const d = new Date();
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const stripAccents = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const byRecent = (a, b) => (b.createdAt || 0) - (a.createdAt || 0) || b.ts - a.ts;

export function downloadBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
